import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import {Accordion, AccordionHeader, AccordionTitle, AccordionSubTitle, AccordionDetail, AccordionItem} from '@vds/accordions';
import { SolutionsList } from './SolutionsList';
import '../../assets/css/homepage.css';
import ModalDialog from './ModalDialog';
import Tiles from './Tiles';
import { saveMetrics, TP_pageLoad, getOS, isNullOrUndefined, checkUrlPath, getCookieValue } from "../modules/CommonFunctions";
import { MetricRTCICall } from "./RTCICall";
import { HOME_PAGE_CATEGORY, MS_LOCATION } from '../../constants/constants';
import {Modal, ModalTitle,ModalBody, ModalFooter} from '@vds/modals'
import {Button} from '@vds/buttons'
import { Tabs, Tab } from "@vds/tabs";
import ErrorBoundary from './ErrorHandler';


class HomePageTab extends React.Component {
    constructor(props) {
        super(props);
        this.isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false;
        this.pegaID = (this.isValidUser && !isNullOrUndefined(window.homePageDynamicData.Attribute) && !isNullOrUndefined(window.homePageDynamicData.Attribute.content)) ? window.homePageDynamicData.Attribute.content : "";
        this.dialogStyle = {
            "top": "50%",
            "position": "fixed",
            "transform": "translate(0%, -45%)"
        };
        this.dialogRef = React.createRef();
        this.tabRef = React.createRef();
        this.contentRef = React.createRef();
        this.state = {
            activeTabIndex: 0,
            dialogData: [],
            showButton : false,
            openDialog: false,
            tabPosition: null,
            // trendingDataList: [],
            // overviewTopSolution: [],
            // billingaccountTopSolution: [],
            //tvTopSolution: [],
            // phoneTopSolution: [],
            //internetTopSolution: []
        }
        this.isMobile = (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? true : false;
        this.header = "";
        this.PopupListItems = [];
        this.selectedTabIndex = "";
        this.selectedTileIndex = "";
        this.tabcount = -1;
        this.toggleAccordion = this.toggleAccordion.bind(this)
    }
   

    closeDialog(e) {
        this.dialogRef.current.classList.add('hide_dialog');
        // document.getElementsByClassName('page-overlay')[0].classList.add('hide_dialog');
        // document.getElementsByClassName('page-overlay')[0].classList.remove('active');
        document.body.classList.remove('position_fixed');
        let tileheadname = this.props.TabData[this.selectedTabIndex].collist[1].boxlist[this.selectedTileIndex].heading;//IR CETC-136749    
        for (var i = 0; i < document.getElementsByClassName('tiny-block-grid-2  margin-all-zero').length; i++) {
            let tileslist = document.getElementsByClassName('tiny-block-grid-2  margin-all-zero')[i];
            for (var k = 0; k < tileslist.getElementsByTagName('li').length; k++) {
                let tilesName = tileslist.getElementsByTagName('li')[k].getAttribute('data-constructscid');
                if (tilesName == tileheadname) {
                    document.getElementsByClassName('tiny-block-grid-2  margin-all-zero')[i].getElementsByTagName('li')[k].firstElementChild.focus();

                }
            }
        }
        this.setState({
            dialogData: []
        })
    }
     
    toggleTab(e, item) {
        let selectedTab = item.tabHeading;
        let tabItem = e.target;
        // window.scLinkTrackID(item.sclinktrackid);  // This need to change
        //  window.constructScData('tab', item.tabId);
        let args = {
            os: getOS(),
            category: HOME_PAGE_CATEGORY,
            subCategory: null,
            pegaSessionID: this.pegaID,
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        }
        MetricRTCICall(args, selectedTab);
        if (tabItem.innerText.toLowerCase() !== "overview") {
            //  TP_pageLoad(item.tabId) // This needs to changes as tppageloadid
        }
        if (tabItem.classList.contains('tabs_tab') && !tabItem.classList.contains('active')) {
            // Hiding previous content
            let previouslySelectedItem = tabItem.parentElement.querySelector('.active');
            let previouslySelectedContent = document.querySelector('.tab-content.active');
            previouslySelectedItem.classList.remove('active');
            previouslySelectedItem.classList.remove('keyboard_focus');
            // previouslySelectedItem.setAttribute('aria-hidden', true);
            previouslySelectedItem.setAttribute('aria-selected', false);
            previouslySelectedItem.setAttribute('tabindex', "-1");
            previouslySelectedContent.classList.remove('active');
            previouslySelectedContent.setAttribute('aria-hidden', true);
            previouslySelectedContent.setAttribute('aria-selected', false);

            // Display Selected Item
            let currentlySelectedItem = tabItem;
            let currentlySelectedItemIndex = parseInt(tabItem.getAttribute('data-item-index'), 10);
            let currentlySelectedContent = document.querySelectorAll('.content' + currentlySelectedItemIndex)[0];
            currentlySelectedItem.classList.add('active');
            currentlySelectedContent.classList.add('active');
            //currentlySelectedItem.setAttribute('aria-hidden', false);
            //  currentlySelectedItem.setAttribute('aria-selected', true);
            currentlySelectedItem.setAttribute('tabindex', "0");
            //  currentlySelectedContent.setAttribute('aria-selected', true)
            currentlySelectedContent.setAttribute('aria-hidden', false)
        }
    }

    handleKeyAction(e) {
        if (e.target.classList.contains('m_article-tabs') || e.target.classList.contains('tabs_tab')) {
            let tabSelectedIndex; let eindex; let activeMenuTabindex;
            let tablist = this.tabRef.current.querySelectorAll('.tabs_tab');
            let currentFocusedTabIndex = parseInt(this.tabRef.current.querySelector('.tabs_tab.active').getAttribute('data-item-index'), 10);
            eindex = parseInt(e.target.attributes["data-item-index"].value);
            if (eindex != null) {
                currentFocusedTabIndex = eindex;
            }
            for (var i = 0; i < tablist.length; i++) {
                let tabariaselected = tablist[i].getAttribute("data-item-Menuselected");
                tabSelectedIndex = parseInt(tablist[i].getAttribute('data-item-index'), 10);
                if (tabariaselected == "true") {
                    activeMenuTabindex = tabSelectedIndex;
                } else {
                }
            }
            if (e.keyCode === 35 || e.keyCode === 36) {
                e.preventDefault();
                let tablist = this.tabRef.current.querySelectorAll('.tabs_tab');
                for (var i = 0; i < tablist.length; i++) {
                    tablist[i].classList.remove('keyboard_focus');
                    tablist[i].setAttribute('tabindex', "-1")
                }
                let selectedtab;
                if (e.keyCode === 36) {
                    selectedtab = this.tabRef.current.querySelectorAll('.tabs_tab')[0];
                } else {
                    selectedtab = this.tabRef.current.querySelectorAll('.tabs_tab')[tablist.length - 1];
                }

                selectedtab.focus();
                selectedtab.classList.add('keyboard_focus');
                selectedtab.setAttribute('tabindex', "0");
            }

            if (e.keyCode === 39) {
                let prevTab = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];
                let nextTab = (!isNullOrUndefined(this.tabRef.current.querySelectorAll('.tabs_tab')
                [currentFocusedTabIndex + 1])) ?
                this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex + 1] 
                : this.tabRef.current.querySelectorAll('.tabs_tab')[0];
                this.setState({ activeTabIndex: 999 });
                if (!isNullOrUndefined(nextTab)) {
                    prevTab.classList.remove('keyboard_focus');
                    prevTab.setAttribute('aria-label', '');
                    prevTab.setAttribute('tabindex', "-1");
                    nextTab.setAttribute('tabindex', "0");
                    nextTab.focus();
                    nextTab.classList.add('keyboard_focus');
                    nextTab.setAttribute('aria-label', '');
                    nextTab.setAttribute('aria-busy', 'false');
                    nextTab.removeAttribute('aria-busy');
                    let tabmenuSelect = nextTab.getAttribute('data-item-Menuselected');
                    if (tabmenuSelect == 'true') {
                        nextTab.setAttribute('aria-selected', true);
                    }
                }
            }

            if (e.keyCode === 37) { 
                
                let totalTabs = this.tabRef.current.querySelectorAll('.tabs_tab').length - 1;
                let prevTab = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];
                let nextTab = (!isNullOrUndefined(this.tabRef.current.querySelectorAll('.tabs_tab')
                [currentFocusedTabIndex - 1])) ?
                    this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex - 1] :
                     this.tabRef.current.querySelectorAll('.tabs_tab')[totalTabs];

                this.setState({ activeTabIndex: 999 });
                if (!isNullOrUndefined(nextTab)) {
                    prevTab.classList.remove('keyboard_focus');
                    prevTab.setAttribute('tabindex', "-1");
                    prevTab.setAttribute('aria-label', '');
                    nextTab.setAttribute('tabindex', "0");
                    nextTab.focus();
                    nextTab.classList.add('keyboard_focus');
                    nextTab.setAttribute('aria-label', '');
                    nextTab.setAttribute('aria-busy', 'false');
                    nextTab.removeAttribute('aria-busy');
                    let tabmenuSelect = nextTab.getAttribute('data-item-Menuselected');
                    if (tabmenuSelect == 'true') {
                        nextTab.setAttribute('aria-selected', true);
                    }
                }
            }
            if (e.keyCode === 9) {
                e.target.classList.remove('keyboard_focus');
                let getTab = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];
                let tabmenuSelect = getTab.getAttribute('data-item-Menuselected');
                let selectedtab = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];
                if (tabmenuSelect == 'true') {
                    getTab.setAttribute('aria-selected', true);
                    selectedtab.setAttribute('aria-description', "");
                }
            }
            if (e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault();
                let tablist = this.tabRef.current.querySelectorAll('.tabs_tab');
                console.log("tesings")
                for (var i = 0; i < tablist.length; i++) {
                    tablist[i].classList.remove('active');
                    tablist[i].setAttribute('aria-selected', 'false');
                    tablist[i].setAttribute('aria-description', "");
                    tablist[i].setAttribute('data-item-Menuselected', 'false');
                    tablist[i].classList.remove('removeborder');
                }
                let totalTabs = this.tabRef.current.querySelectorAll('.tabs_tab').length;
                let needtoShowContent = this.contentRef.current.querySelectorAll('.tab-content')[currentFocusedTabIndex];
                let hideContent = this.contentRef.current.querySelector('[aria-hidden="false"]');
                let selectedtab = this.tabRef.current.querySelectorAll('.tabs_tab')[currentFocusedTabIndex];
                let getTabPosition = Number(selectedtab.getAttribute("data-item-index")) + 1
                let readerVar = `selected ${selectedtab.innerText} tab ${getTabPosition} of ${totalTabs}`
                this.setState({ activeTabIndex: parseInt(selectedtab.getAttribute("data-item-index")) });

                hideContent.classList.remove('active');
                hideContent.setAttribute('aria-selected', false);
                hideContent.setAttribute('aria-hidden', 'true');

                needtoShowContent.classList.add('active');
                // needtoShowContent.setAttribute('aria-selected', true);
                needtoShowContent.setAttribute('aria-hidden', 'false');
                needtoShowContent.classList.remove('keyboard_focus');
                selectedtab.classList.add('active');
                selectedtab.classList.remove('keyboard_focus');
                selectedtab.classList.remove('removeborder');
                // selectedtab.setAttribute('aria-selected', true);
                selectedtab.setAttribute('aria-description', readerVar);
                // selectedtab.setAttribute('aria-busy', 'true');
                selectedtab.setAttribute('data-item-Menuselected', true);
                // selectedtab.setAttribute('aria-description', "");
                // selectedtab.setAttribute('aria-selected', true);
            //     setTimeout(() => {
            //         console.log("Include chat - timer");
            //         try{
                      
            //           //  document.getElementById("idtabcontentwrapper").focus();
            //    // document.querySelectorAll(".tabs_tab")[Number(selectedtab.getAttribute("data-item-index"))].setAttribute('tabindex', "-1");
            //     document.querySelectorAll('.tab-content')[Number(selectedtab.getAttribute("data-item-index"))].setAttribute('tabindex', "0");
            //     document.querySelectorAll('.tab-content')[Number(selectedtab.getAttribute("data-item-index"))].focus();
            //     // selectedtab.setAttribute('aria-description', "");
            //     // selectedtab.setAttribute('aria-selected', true);

            //         }catch(e){console.log("Include chat error :" +e);}
            //         console.log("Include chat - end");
            //     }, 100);
            }
        }
    }
  
   toggleAccordion(index) {
      this.setState(prevState => {
        const newDialogData = prevState.dialogData.map((item, i) => ( i === index && item.isaccordion === "true") ? {...item, isOpened: true} : item )
          return {dialogData: newDialogData};
      })
    } 

     getAccordionContent(item) {
        let accData = [];
        let data = this.props.TabData[this.selectedTabIndex].collist[1].boxlist[this.selectedTileIndex].accordionDataList;
        for (let i = 0; i < data.length; i++) {
            if (data[i].accordionList[0].accordianHeading === item.linktext) {
                accData.push(data[i].accordionList[0]);
            }
        }
        return accData;
    }
    
    getPopupAccordionContent(item) {
        let data = this.props.TabData[this.selectedTabIndex].collist[1].boxlist[this.selectedTileIndex].accordionDataList;
        for (let i = 0; i < data.length; i++) {
            if (data[i].accordionList[0].accordianHeading === item.linktext) {
                return data[i].accordionList[0].linkList[0].Popuplist;
            }
        }
    }

    openModal(e,tileIndex,tabIndex) {

        let tile = (e.target.classList.contains('article-list_item')) ? e.target : e.target.parentElement;

        //  window.constructScData('card', tile.getAttribute('data-constructscid'));
        //window.scLinkTrackID(tile.getAttribute('data-sclintrackid'));
        // saveMetrics(tile.getAttribute('data-metrics'));
        // this.selectedTabIndex = parseInt(document.getElementsByClassName('tabs_tab active')[0].getAttribute('data-item-index'), 10);
        // this.selectedTileIndex = parseInt(tile.getAttribute('data-item-index'), 10);
        this.selectedTabIndex =tabIndex
        this.selectedTileIndex = tileIndex
        
        
        this.header = this.props.TabData[this.selectedTabIndex].collist[1].boxlist[this.selectedTileIndex].heading;
        const rawData = this.props.TabData[this.selectedTabIndex].collist[1].boxlist[this.selectedTileIndex].linkList[0].Popuplist;
        const processedData = rawData.map((item) => item.isaccordion === "true" ? {...item, isOpened: false} : item)
        this.setState({
            dialogData: processedData
        })
        // document.getElementsByClassName('page-overlay')[0].classList.add('active');
        // document.getElementsByClassName('page-overlay')[0].classList.remove('hide_dialog');
        // new modal changes
        this.setState({openDialog: true});
        // document.body.classList.add('position_fixed');
        let selectedTab = this.props.TabData[this.selectedTabIndex].collist[1].boxlist[this.selectedTileIndex].heading;
        let args = {
            os: getOS(),
            category: HOME_PAGE_CATEGORY,
            subCategory: null,
            pegaSessionID: this.pegaID,
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID: (this.isValidUser) ? window.userinfo.visionId : "",
            accountID: (this.isValidUser) ? window.userinfo.visionAcctId : ""
        }
                MetricRTCICall(args, selectedTab);
    }
  
    callSiteCatalyst(e) {
        //window.scLinkTrackID(e.target.getAttribute('data-sclinktrackid'));
    }

    
    componentDidMount() {
        
        const tabKeys = {
            'home': 0,
            'account': 1,
            'internet':2,
            'tv':3,
            'homephone':4
        }

        const lowerCaseRef = window.location.href.toLowerCase();
        Object.keys(tabKeys).forEach(keyword =>{
            if (lowerCaseRef.includes(keyword)) {
                this.setState({ tabPosition: tabKeys[keyword] });
            }
        })

    }
    // componentDidMount() {
    //     let index = 0;
    //     if (window.location.href.toLowerCase().indexOf("internet") > -1) {
    //         this.setState({ tabPosition: 2 });
    //     }
    //     if (window.location.href.toLowerCase().indexOf("homephone") > -1) {
    //         this.setState({ tabPosition: 4 });
    //     }
    //     if (window.location.href.toLowerCase().indexOf('tv') > -1) {
    //         this.setState({ tabPosition: 3 });

    //     }
    //     if (window.location.href.toLowerCase().indexOf('account') > -1) {
    //         this.setState({ tabPosition: 1 });
    //     }
    //     // document.querySelectorAll(".tabs_tab")[index].classList.add('active');
    //     // document.querySelectorAll(".tabs_tab")[index].setAttribute('tabindex', "0");
    //     // document.querySelectorAll('.tab-content')[index].classList.add('active');
    //     // document.querySelectorAll('.tab-content')[index].setAttribute('aria-hidden', "false");

    //     // if (this.isMobile) {
    //     //     document.querySelector('.tab-content-wrapper').addEventListener('click', (e) => {
    //     //         let headerEle = e.target;
    //     //         if (headerEle.classList.contains('top-solutions-header')) {
    //     //             if (headerEle.classList.contains('plus')) {
    //     //                 headerEle.classList.remove('plus');
    //     //                 headerEle.classList.add('minus');
    //     //             } else if (headerEle.classList.contains('minus')) {
    //     //                 headerEle.classList.remove('minus');
    //     //                 headerEle.classList.add('plus');
    //     //             }
    //     //         }
    //     //     })
    //     // }

    //     //Trending top solution from RTCI based on customer metrics

    //     // let url = null;

    //     // url = MS_LOCATION + "/gettrendingnow";
    //     // //url = "https://www98.verizon.com/support/consumer" + "/gettrendingnow";
    //     // const reqData = {};

    //     // fetch(url, {
    //     //     method: "POST",
    //     //     headers: new Headers({
    //     //         "content-type": "application/json"
    //     //     }),
    //     //     body: JSON.stringify(reqData)
    //     // }).then(response => response.json())
    //     // .then(
    //     //         data => this.setState(
    //     //         { 
    //     //             trendingDataList: data.trending,
    //     //             //tvTopSolution: data.trending.TV,
    //     //             internetTopSolution: data.trending.INTERNET
    //     //             //phoneTopSolution: data.trending.PHONE
    //     //         })
    //     //     )
    //     // .catch(error => console.error('Error:', error));
    // }
    closeAction(){
        this.setState({openDialog: false}); 
    }
    openAction() {
        this.setState({ openDialog: true })
        console.log("testing")
        if (this.state.openDialog) {

            setTimeout(() => {
                document.getElementById("modalid").focus();
                document.getElementById("btnClosebutton").focus();
                document.querySelector('.header-title').setAttribute('aria-hidden', 'false')
                document.getElementById("ularticlelist").setAttribute('aria-hidden', 'false')
                console.log(document.getElementById("btnClosebutton"))
            }, 500);

        }
    }
    
    renederTabs(){
        let localInstance = this;
        const{TabData} = this.props;
        const{pegaID, isMobile} = this;

        if (TabData ) {
            return <Tabs
        orientation="horizontal"
        indicatorPosition="bottom"
        linePosition="bottom"
        selectedIndex={this.state.tabPosition}        
    >
        {
            TabData.map((item, index) => {
                const isAvailableDevices = localInstance.props.AvailableDevices.includes(item.tabHeading.toLowerCase())
                    return ( isAvailableDevices ? <Tab
                        label={item.tabHeading}
                        data-track={item.tabHeading}
                        tabPanelAriaLabel={item.tabHeading+" property page"}
                    >
                            <div className="article-top-solutions row">
                                {
                                    <SolutionsList PegaSessionID={pegaID} Title={item.collist[0].topsollist[0].title} Items={item.collist[0].topsollist[0].topsolutions} BannerImage={item.collist[0].imagelist[0].fileReference} />
                                }
                            </div>
                            <Tiles currentTabid={index} isMobile={isMobile} Items={(item.collist[1] !== undefined) ? item.collist[1].boxlist : []} onTileClick={this.openModal.bind(this)} MobileHeader={item.tabHeading} onTileKeyAction={(e) => this.openModal(e)} />

                    </Tab> 
                    : <div>{console.log("No tabHeading")}</div> )   
            })
        }
    </Tabs> 
        }
        
    }

    render() {
        return (
            <section className="main padding-top-medium large-mw-none padding-bottom-zero" role="region">
                <div className="row  border-bottom  tiny-padding-vert-zero">
                    <div className="column tiny-12 padding-vert-zero">
                        <div>
                            <h2 className="inline-block article-title m_padding">{this.props.Header}</h2>
                            <div className="wireless-link medium-right">
                                <a className="button cta-text" href={checkUrlPath(this.props.Link1)} data-sclinktrackid={this.props.Link1SCID} data-track={this.props.Content1} onClick={(e) => this.callSiteCatalyst} aria-label={this.props.Content1}>{this.props.Content1}</a>
                                <span className="divider"></span>
                                <a className="button cta-text margin-left-medium" data-sclinktrackid={this.props.Link2SCID} data-track={this.props.Content2} href={checkUrlPath(this.props.Link2)} onClick={(e) => this.callSiteCatalyst} aria-label={this.props.Content2}>{this.props.Content2}</a>
                            </div>
                        </div>
                        <ErrorBoundary>
                        <div className="padding-top-medium">
                            <ul className="w_tabs m_margin m_article-tabs m_category-tabs"  ref={this.tabRef} role='none presentation'>
                           
                                    {
                                        this.state.tabPosition !== null && this.renederTabs()
                                        }
                                
                            </ul>
                        </div>
                        </ErrorBoundary>
                    </div>
                </div>
                {this.state.openDialog  ?  
                <Modal 
                opened={this.state.openDialog}
               closeButtonId='btnClosebutton'
                surface="light"
                fullScreenDialog={false}
                disableAnimation= {true}
                disableOutsideClick={false}
                id="modalid"
                onOpenedChange={(isOpen)=>{
                    if(isOpen) {
                        {
                           this.openAction()
                    }
                        }
                    else{
                     {
                        this.closeAction()}
                    }
                    }
                }
            >
                <ModalTitle>                   
                <div className='header-title' aria-hidden="true">{this.header}</div>
                </ModalTitle>
                <ModalBody>

                    <ul id="ularticlelist" className="w_list-control m_article-list" data-list-control="" key="Dialog_Content" aria-hidden="true">
                        {
                    (this.state.dialogData).map((item,index)=>{
                        if(item.isaccordion !== "true") {
                        
                        return <li id="liarticleList" data-item-index={index} className="links" key={"accItem"+index}>
                        <a className="m_next" href={checkUrlPath(item.linkurl)} data-track={item.linktext} tabIndex="0" >{item.linktext}</a>
                    </li>
                        }
                        else{
                              return <li className='accordian-wrap links'><Accordion>
                            <AccordionItem>
                                <AccordionHeader 
                                onClick = {() => this.toggleAccordion(index)}
                                ariaLabel={item.linktext}
                                triggerType="icon"
                                >      <AccordionTitle><span className="accordian-title">{item.linktext}</span></AccordionTitle>
                                </AccordionHeader>
                                <AccordionDetail>
                                    <ul className="w_list-control m_article-list">
                                {this.getPopupAccordionContent(item).map((innerItem, innerIndex) => <li id="inner-liarticleList" data-item-index={index} className="links" key={"accInnerItem"+innerIndex}>
                        <a className="m_next" href={checkUrlPath(innerItem.linkurl || '')} data-track={innerItem.linktext} tabIndex={item.isOpened === true ? "0" : "-1"} >{innerItem.linktext}</a>
                    </li>)}
                                </ul>
                                </AccordionDetail>
                            </AccordionItem>
                            </Accordion></li>
                            //return <AccordionOld HeaderClass="hide_header" Header=""  DataSource={this.getAccordionContent(item)} PopupList={this.getPopupAccordionContent(item)}/>
                        }

                    },this)
                    }
                    </ul>                
                </ModalBody>
            </Modal>
            
                : null}
            </section>
                
        )
    }
}

export default HomePageTab




// WEBPACK FOOTER //
// ./src/components/modules/HomePageTab.js